import axios from 'axios';
import _ from 'lodash';
import P from 'bluebird';

const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'testing'
const defaultOptions = {
    crossDomain: true,
    normalize: true,
    json: true
};
const mapKeys = {
    baseUrl: 'baseURL',
    uri: 'url',
    qs: 'params',
    body: 'data'
};

export default class Service {
    constructor(name) {
        this.name = name
        this.axios = axios.create({ baseURL: this.baseURL })
    }

    get baseURL () {
        switch (ENVIRONMENT) {
            case 'testing':
            case 'development':
                return `https://api-test.dinclin.com/${this.name}`
            case 'staging':
                return `https://api-stag.dinclin.com/${this.name}`
            default:
                return `https://api.dinclin.com/${this.name}`
        }
    }

    setToken(value) {
        this.axios.defaults.headers.common.Authorization = `bearer ${value}`
    }

    async request ({ url, method, ...options }) {
        return P.bind(this)
            .then(() => {
                return new P((resolve, reject) => {
                    const opts = this.prepareOptions(method, {...options, url});

                    return this.axios
                                    .request(opts)
                                    .then(res => resolve(opts.raw ? res : res.data))
                                    .catch(error => reject(error));
                                });
                            });
    };


    async get(url, options) { 
        return this.request({ url, method: 'GET', ...options }) 
    }

    async post(url, options) {
        return this.request({ url, method: 'POST', ...options }) 
    }

    async put(url, options) {
        return this.request({ url, method: 'PUT', ...options }) 
    }

    async patch(url, options) {
        return this.request({ url, method: 'PATCH', ...options }) 
    }

    async delete(url, options) {
        return this.request({ url, method: 'DELETE', ...options }) 
    }

    prepareOptions (method, options) {
        if (_.isString(options)) {
            options = {
                url: options,
            };
        }

        // if (!_.startsWith(options.url, 'http')) {
        //     options.url = `${this.baseUrl}${options.url}`;
        // }

        options.method = method || 'get';

        options = _.defaultsDeep({}, _.mapKeys(options, (value, key) => mapKeys[key] || key), defaultOptions);

        return options;
    }
}